import React from "react";
import ReactModal from "react-modal";

import { WebTracker } from "../../types";
import { WebTrackerFollowUpTask } from "./FollowUpTasksTypes";
import SetupIntegration from "./SetupIntegration";
import UninstallTracker from "./UninstallTracker";

export type FollowUpTaskDetailsModalProps = {
  onClose: () => void;
  siteDomain: string;
  trackerDomain: string;
  webTracker: WebTracker;
  followUpTask: WebTrackerFollowUpTask | null;
};

function FollowUpTaskDetailsModal({
  onClose,
  siteDomain,
  trackerDomain,
  webTracker: tracker,
  followUpTask,
}: FollowUpTaskDetailsModalProps) {
  const customStyles = {
    content: {
      zIndex: 10050,
      minHeight: `20vh`,
      maxHeight: 700,
      top: "auto",
      bottom: "auto",
      right: "auto",
      left: "auto",
      position: "static" as "static",
      display: "flex",
      padding: 0,
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, .5)",
      zIndex: 10000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  };

  if (!followUpTask) {
    return <></>;
  }

  if (
    ["set_up_destination", "set_up_video_proxy", "set_up_fp_maps"].includes(
      followUpTask
    )
  ) {
    return (
      <ReactModal
        isOpen={true}
        onRequestClose={onClose}
        style={customStyles}
        contentLabel="Setup Freshpaint Integration"
      >
        <SetupIntegration
          onClose={onClose}
          siteDomain={siteDomain}
          trackerDomain={trackerDomain}
          tracker={tracker}
          followUpTask={followUpTask}
        />
      </ReactModal>
    );
  }

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Uninstall Tracker"
    >
      <UninstallTracker onClose={onClose} tracker={tracker} />
    </ReactModal>
  );
}

export default FollowUpTaskDetailsModal;
